import { languageService } from "../../../Language/language.service";

export const customForm_AppFormCustomAttrs = {
  title: "Add/Edit Form Attribute",
  id: "customForm_AppFormCustomAttrs",
  stateTitle: {
    create: languageService("Add Form Attribute"),
    edit: languageService("Edit Form Attribute"),
  },
  sections: [
    {
      id: "appFormAttrsSection",
      fields: [
        {
          id: "id", // required
          type: "input", // required
          labelValue: "Attribute Id",
          required: true,
          disabledStates: ["edit"],
        },
        {
          id: "name", // required
          type: "input", // required
          labelValue: languageService("Field Name"),
          disabledStates: ["edit"],
        },
        {
          id: "values", // required
          type: "createableSelect", // required
          labelValue: languageService("Allowed Values"),
          hintMessage: languageService("Type any value and press enter"),
        },
      ],
    },
    {
      id: "appFormAttrsButtonsSection",
      fields: [
        {
          id: "addFormAttribute", // required
          type: "button", // required
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addFormAttribute",
          position: "footer",
          hiddenStates: ["edit"],
          col: 6,
        },
        {
          id: "updateFormAttribute", // required
          type: "button", // required
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateFormAttribute",
          position: "footer",
          hiddenStates: ["create"],
          col: 6,
        },
        {
          id: "cancelFormAttrDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/AppFormCustomAttrs/schemas/customForm_AppFormCustomAttrs.js